<template>
  <div class="modal-disclaimer">
    <div :class="{ 'collapsed': isSnippet }" ref="disclaimer">
      <p>
        <span>The phone and/or email you provide here will replace the previously provided information.</span>
       
      </p>
      <p>
        By selecting the "Send" button below you agree to receive a confirmation notification. Message
        and data rates may apply.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalDisclaimer",
  data() {
    return {
      isSnippet: false,
    };
  },
  methods: {
    toggleDisclaimer() {
      this.isSnippet = !this.isSnippet;
      this.$nextTick(() => {
        const cls = this.$refs.disclaimer.classList;
        if (!cls.contains('collapsed')) {
          cls.add('expanded')
        }
        this.$emit('doDisclaimer', this.isSnippet);
      });
     },
  }
}
</script>

<style lang="scss" scoped>
.modal-disclaimer {
  --whitespace: calc(var(--padding-horizontal) * 0.5);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 var(--whitespace) 0;
  margin: 0.5em calc(var(--whitespace) * -1) 1em calc(var(--whitespace) * -1);
  button.toggle {
    margin: 0 0 0 0.05em;
    padding: 0 0.5em 0.5em;
    min-width: var(--icon-dimension);
    height: min-content;
    img {
      width: 16px;
    }
  }
  p {
    color: var(--ri-blue);
    font-size: 0.9rem;
    padding: 0.1em 0 1em;
    @extend %font-sans-semibold;
    span:nth-child(2) {
      &::before {
        content: ' ';
      }
    }
  }
  .collapsed {
    height: 63px;
    overflow: hidden;
    p:first-child {
      span {
        &:first-child {
          &::after {
            content: '..';
          }
        }
        &:nth-child(2) {
          visibility: hidden;
        }
      }
    }
  }
  .expanded {
    animation: fadeIn;
    animation-duration: 2s;
    height: max-content;
  }
}
</style>
